export const environment = {
  production: true,
  apiRoot: `https://api.eceos.cloud/v1`
};
